import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios, { getParams } from '@utils/request'
import { makeRequestQuery } from '@utils/helpers/queryHelpers'
import { IListQueryPaginationPayload } from '@app-store/slices/editList/list'
import { editListQueryMap } from '@utils/QueryMaps'

interface TaskAction extends Action {
    payload: IListQueryPaginationPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.editList.list

function* listSagaTask({ payload }: TaskAction) {
    const params = yield getParams(payload)
    const query = payload.query || {}
    const editListQuery = makeRequestQuery(editListQueryMap)
    if (query) Object.assign(params, { query: { ...query, ...JSON.parse(editListQuery) } })
    try {
        const response = yield axios.get(`/companies/edit-lists`, {
            params
        })
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* listSaga(): any {
    yield takeLatest<TaskAction>(onRequest, listSagaTask)
}

export default listSaga
